jQuery(function ($) {
    $(document).ready(function () {
        if ($("a[href=#login-form-modal]").length > 0) {
            $('a[href=#login-form-modal]').on('click', function () {
                $('#login-form-modal').removeClass('-translate-y-[101%] opacity-0 -top-full').addClass('flex top-0');
                $('.login-form-modal-close').addClass('fixed');
                $('html').css('overflow-y', 'hidden');

                $('#login-form-modal').on('click', '.login-form-modal-close', function () {
                    $('#login-form-modal').addClass('-translate-y-[101%] opacity-0 -top-full').removeClass('flex top-0');
                    $('.login-form-modal-close').removeClass('fixed');
                    $('html').css('overflow-y', '');
                });
            });
        }
    });
});